import { defineStore } from 'pinia';

import { sellerPay } from '@/api/point';

interface PayState {
  payMoney: number
  isFinish: boolean
}

export const useSellerPay = defineStore({
  id: 'seller-pay',
  state: (): PayState => ({
    payMoney: 0,
    isFinish: false,
  }),
  getters: {},
  actions: {
    setPayMoney(money: number) {
      this.payMoney = money;
    },
    async rechargePay(data: API.PayParam) {
      return sellerPay(data);
    },
  },
});
